/** Paleta única de WSS Live: el tipo de actividad define el color en todas las
 *  vistas (mes, semana, tarjetas y detalle). */
export const LIVE_TYPES = [
  "conversation", "grammar", "pronunciation", "five_finger",
  "costa_rican_spanish", "everyday_spanish", "listening", "qa", "other",
];

export const LIVE_TYPE_STYLE = {
  conversation: {
    chip: "bg-blue-50 text-blue-700 border-blue-200", dot: "bg-blue-500",
    pill: "bg-blue-50 border-blue-300 text-blue-900 hover:bg-blue-100",
    cover: "from-blue-500 via-blue-600 to-indigo-700", text: "text-blue-700",
  },
  grammar: {
    chip: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "bg-emerald-500",
    pill: "bg-emerald-50 border-emerald-300 text-emerald-900 hover:bg-emerald-100",
    cover: "from-emerald-500 via-emerald-600 to-teal-700", text: "text-emerald-700",
  },
  pronunciation: {
    chip: "bg-purple-50 text-purple-700 border-purple-200", dot: "bg-purple-500",
    pill: "bg-purple-50 border-purple-300 text-purple-900 hover:bg-purple-100",
    cover: "from-purple-500 via-purple-600 to-fuchsia-700", text: "text-purple-700",
  },
  five_finger: {
    chip: "bg-indigo-50 text-indigo-700 border-indigo-200", dot: "bg-indigo-500",
    pill: "bg-indigo-50 border-indigo-300 text-indigo-900 hover:bg-indigo-100",
    cover: "from-indigo-500 via-indigo-600 to-blue-800", text: "text-indigo-700",
  },
  costa_rican_spanish: {
    chip: "bg-orange-50 text-orange-700 border-orange-200", dot: "bg-orange-500",
    pill: "bg-orange-50 border-orange-300 text-orange-900 hover:bg-orange-100",
    cover: "from-orange-400 via-orange-500 to-red-600", text: "text-orange-700",
  },
  everyday_spanish: {
    chip: "bg-teal-50 text-teal-700 border-teal-200", dot: "bg-teal-500",
    pill: "bg-teal-50 border-teal-300 text-teal-900 hover:bg-teal-100",
    cover: "from-teal-400 via-teal-500 to-cyan-700", text: "text-teal-700",
  },
  listening: {
    chip: "bg-rose-50 text-rose-700 border-rose-200", dot: "bg-rose-500",
    pill: "bg-rose-50 border-rose-300 text-rose-900 hover:bg-rose-100",
    cover: "from-rose-400 via-rose-500 to-pink-700", text: "text-rose-700",
  },
  qa: {
    chip: "bg-amber-50 text-amber-800 border-amber-200", dot: "bg-amber-500",
    pill: "bg-amber-50 border-amber-300 text-amber-900 hover:bg-amber-100",
    cover: "from-amber-400 via-amber-500 to-orange-600", text: "text-amber-700",
  },
  other: {
    chip: "bg-slate-100 text-slate-700 border-slate-200", dot: "bg-slate-400",
    pill: "bg-slate-50 border-slate-300 text-slate-800 hover:bg-slate-100",
    cover: "from-slate-500 via-slate-600 to-slate-800", text: "text-slate-700",
  },
};

export const liveStyle = (type) => LIVE_TYPE_STYLE[type] || LIVE_TYPE_STYLE.other;
